import svc from 'svc';
import { parseResponse } from 'utilities/Utility';



export default function query(id, data = {}) {
	return svc.send('passthrough', {
		Type: 'RepoPDQ',
		ID: id,
		...data
	}).then((res) => {
		let success = false;

		try {
			success = res.payload.Data.Result.CallSucceeded;
		} catch (err) {
			success = false;
		}

		if (!success) {
			return Promise.reject(res);
		}

		try {
			res.payload.parsed = parseResponse(res.payload);
		} catch (err) {
			res.payload.parsed = null;
		}

		return res.payload;
	}).catch(err => {
		return Promise.reject(err);
	});
}


// WEBPACK FOOTER //
// ./src/svc/query.js